/**
 * Size the iframe frame reports while the panel is open.
 *
 * The frame is an opaque rectangle that clips whatever overflows it, so besides the panel
 * it must hold the panel's anchoring margins (16px side + 16px top + the launcher lane
 * below) AND the panel's drop shadow. The shadow reaches further than the 16px margins on
 * the two sides that are not pinned to the viewport corner (the far side and the top):
 * light `0 24px 64px` reaches 64px left / 40px up, dark `0 32px 80px` reaches 80px left /
 * 48px up. Without the extra room the shadow is cut in a hard edge on every open.
 *
 * Growing the frame is invisible: the panel is positioned from the frame's bottom corner,
 * so extra width/height only adds transparent room on the far side and the top.
 */

/** Extra room beyond the 16px margin: dark shadow 80px - 16px. */
export const OPEN_SHADOW_PAD_X = 64;
/** Extra room beyond the 16px margin: dark shadow 80px blur - 32px offset - 16px. */
export const OPEN_SHADOW_PAD_Y = 32;

export function openFrameSize(
  idealW: number,
  idealH: number,
  margins: { marginX: number; marginY: number },
): { width: number; height: number } {
  return {
    width: idealW + margins.marginX + OPEN_SHADOW_PAD_X,
    height: idealH + margins.marginY + OPEN_SHADOW_PAD_Y,
  };
}
